module.exports = "/images/restaurant.svg";